var path = 'app/scripts/modules/oracle/pipeline/stages/disableAsg/disableAsgStepLabel.html';
var html = "<span class=\"task-label\">\n  Disable Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/oracle/pipeline/stages/disableAsg/disableAsgStepLabel.html
// module id = 1704
// module chunks = 0